<ng-container *vsLet="staffView$ | async as staffView">
  <ng-container *vsLet="isLargeScreen$ | async as isLargeScreen">
    <ng-container *vsLet="session$ | async as session">
      <ng-container *vsLet="assets$ | async as assets">
        <ng-container *ngIf="assets && assets.length > 0 && !createNew; else noAssetList">
          <div class="relative flex flex-col items-center gap-4 mb-2">
            <div class="flex gap-2 w-full items-center">
              <div class="w-12 h-12">
                <button
                  vs-icon-button
                  appearance="clear"
                  theme="default"
                  size="lg"
                  *ngIf="!isLargeScreen"
                  (click)="previousPage(staffView ?? false)"
                >
                  <vs-icon name="chevron-left" size="20"></vs-icon>
                </button>
              </div>
              <div class="flex justify-center items-center flex-grow" name="icon">
                <vs-featured-icon
                  [name]="$any(session?.policy?.propertySet?.icon) || 'diamond-01'"
                  theme="primary"
                ></vs-featured-icon>
              </div>
              <div class="w-12 h-12">
                <button
                  vs-icon-button
                  appearance="clear"
                  theme="default"
                  size="lg"
                  [disabled]="!stepCompleted || !assetComplete || !session?.customerId || !session?.policyId"
                  *ngIf="!isLargeScreen"
                  (click)="nextPage(session, staffView ?? false)"
                >
                  <vs-icon name="chevron-right" size="20"></vs-icon>
                </button>
              </div>
            </div>
            <div name="title" class="text-3xl font-semibold leading-[38px] text-center">
              {{
                'Tell us about your ' +
                  (staffView ? "customer's " : '') +
                  (session?.policy?.propertySet?.name | lowercase) +
                  '.'
              }}
            </div>

            <div name="subtitle" class="text-sm text-gray-600 mb-8" *ngIf="assetPicker.totalAssets > 0">
              Please select your {{ staffView ? "customer's " : '' }} existing
              {{ session?.policy?.propertySet?.name ?? 'asset' | lowercase }}.
            </div>
          </div>

          <div>
            <ws-asset-picker
              #assetPicker
              [session]="session"
              [assets]="assets"
              [formControl]="asset"
              [staffView]="staffView ?? false"
              (assetsReload)="reloadAssets()"
            ></ws-asset-picker>

            <div *ngIf="stepCompleted && assetComplete === false" class="text-sm text-danger mt-2 mb-1 text-center">
              This asset is missing required details. Edit it to fill them in before continuing.
            </div>

            <div class="flex justify-evenly place-items-center" *ngIf="assetPicker.totalAssets > 0">
              <vs-divider></vs-divider>
              <pre> <span class="font-sans subpixel-antialiased text-gray-600 text-xs">Or</span> </pre>
              <vs-divider></vs-divider>
            </div>

            <button
              vs-button
              theme="primary"
              appearance="outline"
              class="bg-primary-50 text-primary-700 !w-full font-semibold mt-3"
              (click)="newAsset()"
            >
              <vs-icon name="plus"></vs-icon>
              Add new asset
            </button>
          </div>
          <div class="flex gap-3 mt-4" [class.flex-col]="!isLargeScreen">
            <button
              [class]="!isLargeScreen ? 'min-w-full' : ''"
              vs-button
              (click)="previousPage(staffView ?? false)"
              appearance="outline"
            >
              Back
            </button>

            <button
              [class]="!isLargeScreen ? 'min-w-full' : ''"
              vs-button
              theme="primary"
              (click)="nextPage(session, staffView ?? false)"
              [disabled]="!stepCompleted || !assetComplete || !session?.customerId || !session?.policyId"
            >
              <div class="flex gap-3 items-center">
                <span>Continue</span>
                <vs-icon *ngIf="stepCompleted" name="check"></vs-icon>
              </div>
            </button>
          </div>
        </ng-container>

        <!-- Assets still loading: show a placeholder, not the new-asset form meant for customers with no assets -->
        <ng-template #noAssetList>
          <div
            *ngIf="assets === null && !createNew; else newAssets"
            class="flex flex-col items-center gap-4 w-[32rem] max-w-full animate-pulse"
          >
            <div class="w-12 h-12 rounded-full bg-gray-200"></div>
            <div class="h-9 w-3/4 rounded bg-gray-200"></div>
            <div class="h-4 w-1/2 rounded bg-gray-200 mb-8"></div>
            <div class="flex flex-col gap-2 w-full">
              <div
                *ngFor="let _ of [1, 2, 3]"
                class="flex gap-2 w-full rounded-lg p-4 border-2 border-gray-200 bg-base"
              >
                <div class="w-6 h-6 rounded-full bg-gray-200 self-center"></div>
                <div class="flex flex-col gap-2 pt-1 flex-grow">
                  <div class="h-3 w-24 rounded bg-gray-200"></div>
                  <div class="flex gap-2 items-center">
                    <div class="h-5 w-16 rounded-full bg-gray-200"></div>
                    <div class="h-3 w-48 rounded bg-gray-200"></div>
                  </div>
                  <div class="flex gap-2 items-center">
                    <div class="h-5 w-24 rounded-full bg-gray-200"></div>
                    <div class="h-3 w-12 rounded bg-gray-200"></div>
                  </div>
                </div>
                <div class="w-5 h-5 rounded-full bg-gray-200"></div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #newAssets>
        <ws-provision-confirmation></ws-provision-confirmation>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
